import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentComponent } from './payment.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PaymentRoutingModule } from './payment-routing.module';
import {
  MatCheckboxDefaultOptions,
  MAT_CHECKBOX_DEFAULT_OPTIONS,
} from '@angular/material/checkbox';
import {
  FinalFactorComponent,
  NextStepBtnComponent,
  OrderReviewModeComponent,
  PaymentNavigationComponent,
  PaymentStatusPhoneComponent,
  PaymentStatusWebComponent,
  PaymentSubmitBtnComponent,
  ResultComponent,
  SelectOrdersComponent,
  SubmitComponent,
  TransformationOrderComponent,
  TransportationComponent,
} from './components';
import { PaymentService } from './services';
import {
  SelectableOrderComponent,
  SelectableOrderContainerComponent,
} from '..';
import { PaymentOrderFactorComponent } from './components/payment-order-factor/payment-order-factor.component';

@NgModule({
  declarations: [
    PaymentNavigationComponent,
    TransportationComponent,
    FinalFactorComponent,
    NextStepBtnComponent,
    PaymentComponent,
    PaymentStatusPhoneComponent,
    PaymentStatusWebComponent,
    PaymentStatusPhoneComponent,
    SelectOrdersComponent,
    SelectableOrderComponent,
    SelectableOrderContainerComponent,

    TransformationOrderComponent,
    PaymentStatusPhoneComponent,
    PaymentSubmitBtnComponent,
    SubmitComponent,
    ResultComponent,
    OrderReviewModeComponent,
    PaymentOrderFactorComponent,
  ],
  providers: [
    PaymentService,

    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: {
        clickAction: 'noop' as MatCheckboxDefaultOptions,
      },
    },
  ],
  imports: [CommonModule, PaymentRoutingModule, SharedModule],
})
export class PaymentModule {}
